import { render } from "./designSubFormPrint.vue?vue&type=template&id=0e1b6ce8"
import script from "./designSubFormPrint.vue?vue&type=script&lang=js"
export * from "./designSubFormPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__